export default __webpack_public_path__ + "static/media/truck.6a2b34f8.svg";